import { DataRow } from '@uni-space/uni-components';
import { ParcelDto } from '@shared/types/parcel';
import { CancellationReasonItem } from './useCancellationReasons';

export enum CancellationPhotoRowStatus {
  /** Отмена прошла, снимок ещё не сделан — строка обновится после фото. */
  AwaitingPhoto = 'awaitingPhoto',
  /** Фото сохранено, посылка отменена этим скан-сеансом. */
  Canceled = 'canceled',
  /** Фото сохранено, посылка уже была отменена раньше — события отмены повторно не ставились. */
  AlreadyCanceled = 'alreadyCanceled',
  NotFound = 'notFound',
  /** Фото не принято или отмена не выполнена; текст — в errorMessage. */
  Error = 'error',
}

export type CancellationPhotoRow = DataRow<{
  id: string;
  trackNumber: string;
  status: CancellationPhotoRowStatus;
  reasonLabel?: string;
  /** false — у посылки уже было фото отмены, Media оставил прежнее. */
  isPhotoNew?: boolean;
  errorMessage?: string;
  at: Date;
}>;

/**
 * Шаг оператора по текущей посылке: скан → выбор причины и отмена → снимок.
 * `reason` — причина, с которой посылка отменена на этом шаге; у пришедшей уже отменённой её нет.
 */
export type CancellationPhotoStage =
  | { kind: 'idle' }
  | { kind: 'reason'; parcel: ParcelDto }
  | { kind: 'photo'; parcel: ParcelDto; reason: CancellationReasonItem | null; rowId: string | null };

/** Последний снимок текущей смены — показывается рядом с камерой, чтобы оператор видел, что ушло. */
export interface LastShot {
  trackNumber: string;
  dataUrl: string;
}

/** Снимок с камеры приходит data URL (PNG без потерь, как на ручной приёмке); на сервер уходит файлом. */
export async function dataUrlToBlob(dataUrl: string): Promise<Blob> {
  const response = await fetch(dataUrl);
  return response.blob();
}
